import { APP_NAMES } from "@constants/Enums";

// get and return the current date in japanese format (YYY-MM-dd)
export const GetCurrentDate = () => {
  const date = new Date();

  const options = {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  return new Intl.DateTimeFormat("ja-JP", options)
    .format(date)
    .replace(
      /(\d{4})\/(\d{2})\/(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/,
      "$1$2$3$4$5$6",
    );
};

export const ConvertToJapaneseTime = (date: string) => {
  const newDate = new Date(date);

  const jstDate = new Date(newDate.getTime() + 9 * 60 * 60 * 1000);

  const formattedDate = `${jstDate.getFullYear()}年${
    jstDate.getMonth() + 1
  }月${jstDate.getDate()}日　${jstDate.toTimeString().split(" ")[0]}`;

  return formattedDate;
};

// convert all double width and half width spaces to single width
export const NormalizeSpaces = (input) => {
  return input.replace(/[\u0020\u3000]+/g, " ");
};

// returns the password policy
export const GetPasswordPolicy = () => {
  return "英字大文字、小文字、数字、記号を全て含み、8文字以上";
};

export const sortApps = (appInfo) => {
  const appsOrder = [APP_NAMES.KAKELY, APP_NAMES.YOBELY, APP_NAMES.WORKJOY];

  const sorted = [...appInfo].sort((a, b) => {
    const indexA = appsOrder.indexOf(a.app_name || a.name);
    const indexB = appsOrder.indexOf(b.app_name || b.name);
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  return sorted;
};

export const removeHyphens = (input) => {
  if (!input) return input;
  return input.replace(/-/g, "");
};

export const GenerateRandomPassword = (length = 12) => {
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const symbols = "!@#$%^&*()_+";
  const allCharacters = uppercase + lowercase + numbers + symbols;

  let password = "";

  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];

  for (let i = 4; i < length; i++) {
    password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
  }

  password = password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return password;
};
